import { TenantFormPage } from '@tom-ui/admin'
import { SingleLocationCodeAutoComplete } from '@tom-ui/planning'
import { observer } from 'mobx-react-lite'

export const TenantCreationPage = observer(() => (
  <TenantFormPage SingleLocationCodeAutoComplete={SingleLocationCodeAutoComplete} />
))
